export enum SupplierRequestCancellationReason {
    SUPPLIER_OPTED_OUT = 'SUPPLIER_OPTED_OUT',
    CUSTOMER_CANCELLED = 'CUSTOMER_CANCELLED',
    SUPPLIER_NONRESPONSIVE = 'SUPPLIER_NONRESPONSIVE',
}

export enum SupplierRequestCancellationReasonLabels {
    SUPPLIER_OPTED_OUT = 'Supplier Opted Out',
    CUSTOMER_CANCELLED = 'Customer Cancelled',
    SUPPLIER_NONRESPONSIVE = 'Supplier Nonresponsive',
}